import { render, staticRenderFns } from "./DisableOrEnableParameters.vue?vue&type=template&id=20b5c538&scoped=true"
import script from "./DisableOrEnableParameters.vue?vue&type=script&lang=js"
export * from "./DisableOrEnableParameters.vue?vue&type=script&lang=js"
import style0 from "./DisableOrEnableParameters.vue?vue&type=style&index=0&id=20b5c538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b5c538",
  null
  
)

export default component.exports